// frontend_app/src/utils/helpers.js

/**
 * Determines if a result item from the backend is a valid, displayable result.
 * Relies on the 'is_displayable' flag set by the backend parsers.
 * @param {object} result - The result item from the backend.
 * @returns {boolean} - True if the item should be displayed.
 */
export const isActualDisplayableResultItem = (result) => {
  return result && result.is_displayable === true;
};